// Generated by scripts/generate_component_entries.mjs from packages/client/component-entries.json.
// Do not edit by hand.
import type {Alpine as AlpineType} from 'alpinejs';

import {registerButton as registerComponent} from './index';

const registerButton = (): void => {
    registerComponent();
};

export {registerButton};
export default registerButton;
export * from './index';
